// extracted by mini-css-extract-plugin
export var cartContainer = "_o9-4";
export var gray = "_o9-1";
export var itemContainer = "_o9-2";
export var itemDetails = "_o9-3";
export var strong = "_o9-0";